import moment from "moment";
import { z } from "zod";

import { Command } from "../../types";

export enum SKR {
  SKR03 = "SKR03",
  SKR04 = "SKR04",
}

export const datevExportSchema = z.object({
  command: z.literal(Command.DatevExport),
  skr: z.nativeEnum(SKR),
  date: z.custom<moment.Moment>((date) => moment.isMoment(date), {
    message: "Please select a date",
  }),
  withReceipts: z.boolean(),
});

export type DatevExportValues = z.infer<typeof datevExportSchema>;
